import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-bar" }
const _hoisted_2 = { class: "page-bar-main" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_5 = { class: "playbook" }
const _hoisted_6 = {
  id: "playbook-sheet-wrap",
  class: "playbook-sheet-wrap skills-matrix-sheet-wrap"
}
const _hoisted_7 = {
  id: "playbook-sheet",
  class: "playbook-sheet skills-matrix-sheet"
}
const _hoisted_8 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onUpdate:modelValue", "onChange"]
const _hoisted_14 = { value: 0 }
const _hoisted_15 = { value: 1 }
const _hoisted_16 = { value: 2 }
const _hoisted_17 = { value: 3 }
const _hoisted_18 = { value: 4 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { colspan: "42" }
const _hoisted_21 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_22 = { style: {"padding-left":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_add_edit_skills_matrix = _resolveComponent("add-edit-skills-matrix")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "page-bar-sub" }, "Team / Skills Matrix", -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formData.Name), 1)
      ])
    ]),
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
          }, [
            (_ctx.$store.state.user.teamHubRole == 'Admin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = () => { _ctx.showEdit = true }),
                          class: "add-btn"
                        }, "Edit Name/Columns"),
                        _createElementVNode("div", {
                          onClick: _cache[1] || (_cache[1] = () => { _ctx.editMode = false; _ctx.setDoubleScroll(); }),
                          class: "add-btn"
                        }, "View Mode")
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = () => { _ctx.editMode = true; _ctx.setDoubleScroll(); }),
                        class: "add-btn"
                      }, "Edit Mode"))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ColumnsJSON, (col, i) => {
                        return (_openBlock(), _createElementBlock("td", { key: i }, _toDisplayString(col.name), 1))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                        _createElementVNode("td", null, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((row.Name) = $event)
                                }, null, 8, _hoisted_9), [
                                  [_vModelText, row.Name]
                                ]),
                                _createElementVNode("span", {
                                  onClick: _withModifiers(($event: any) => (_ctx.deleteRow(row)), ["prevent"])
                                }, [
                                  _createVNode(_component_svg_icon, {
                                    style: {"width":"18px","height":"18px","color":"red"},
                                    icon: "x"
                                  })
                                ], 8, _hoisted_10)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(row.Name), 1))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ColumnsJSON, (col, j) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: 'c'+j
                          }, [
                            (_ctx.editMode)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((row.ColumnsJSON[col.id]) = $event),
                                    onChange: ($event: any) => (_ctx.submitRow(row))
                                  }, [
                                    _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.ratings[0].label), 1),
                                    _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.ratings[1].label), 1),
                                    _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.ratings[2].label), 1),
                                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.ratings[3].label), 1),
                                    _createElementVNode("option", _hoisted_18, _toDisplayString(_ctx.ratings[4].label), 1)
                                  ], 40, _hoisted_13), [
                                    [_vModelSelect, row.ColumnsJSON[col.id]]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_svg_icon, {
                                    style: _normalizeStyle('fill:'+_ctx.ratings[row.ColumnsJSON[col.id]].color),
                                    icon: "circle"
                                  }, null, 8, ["style"])
                                ]))
                          ]))
                        }), 128))
                      ]))
                    }), 128)),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                            return _createElementVNode("div", {
                              key: i,
                              style: {"display":"flex","align-items":"center","margin":"5px 10px"}
                            }, [
                              _createVNode(_component_svg_icon, {
                                style: _normalizeStyle('fill:'+_ctx.ratings[i-1].color),
                                icon: "circle"
                              }, null, 8, ["style"]),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.ratings[i-1].label), 1)
                            ])
                          }), 64))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.editMode)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.addTeammate()), ["prevent"])),
                    style: {"display":"flex","margin-top":"20px"}
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.teammateInput) = $event)),
                      type: "text",
                      placeholder: "Teammate Name"
                    }, null, 512), [
                      [_vModelText, _ctx.teammateInput]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("button", { class: "add-btn" }, "Add Teammate", -1))
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (_ctx.showConfirmDelete)
            ? (_openBlock(), _createBlock(_component_confirm_delete, {
                key: 0,
                onConfirm: _ctx.deleteConfirm,
                onCancel: _cache[5] || (_cache[5] = () => { _ctx.showConfirmDelete = false; }),
                msg: "Are you sure you would like to delete this row?"
              }, null, 8, ["onConfirm"]))
            : _createCommentVNode("", true),
          (_ctx.showEdit)
            ? (_openBlock(), _createBlock(_component_add_edit_skills_matrix, {
                key: 1,
                onClose: _cache[6] || (_cache[6] = () => { _ctx.showEdit = false; _ctx.getData() }),
                matrixToEdit: _ctx.formData
              }, null, 8, ["matrixToEdit"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}